import React, { useCallback } from 'react'
import { useMsal } from '@azure/msal-react'
import Task from 'data.task'
import { isMsAuthEnabled, noopTaskCallback } from './utils'

const useTokensGetter = () => {
  const { instance } = useMsal()
  const logout = useCallback(
    () =>
      new Task((err, resolve) => {
        instance
          .logoutPopup()
          .then(resolve)
          .catch(err)
      }),
    [instance]
  )
  return [isMsAuthEnabled ? logout : noopTaskCallback]
}

export default useTokensGetter
